export const saveToLocalStorage = data => {
  window.localStorage.setItem("disco", JSON.stringify(data));
};

export const loadFromLocalStorage = data => {
  const res = window.localStorage.getItem("disco");
  return JSON.parse(res) || {};
};

export const clearLocalStorage = () => {
  window.localStorage.setItem("disco", JSON.stringify({}));
};

export const hasTouch = () => {
  return (
    "ontouchstart" in document.documentElement ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

const agent = navigator.userAgent;
export const isIphone =
  agent.indexOf("iPhone") != -1 || agent.indexOf("iPod") != -1;

export const getLanguage = lang => {
  switch (lang) {
    case lang.includes("en"):
      return "en";
    case lang === "ja":
      return "ja";
    default:
      return "en";
  }
};

export const clamp = (value, min, max) => {
  return Math.min(Math.max(value, Math.min(min, max)), Math.max(min, max));
};

export const remap = (value, low1, high1, low2, high2) => {
  return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);
};

export const sectionScale = width => {
  if (width <= 1660) {
    return clamp(remap(width, 1250, 1660, 0.5, 0.7), 0.5, 1).toFixed(2);
  } else {
    return clamp(remap(width, 1660, 1900, 0.7, 0.8), 0.7, 1).toFixed(2);
  }
};

export const checkIsPC = width => (width ? width >= 750 : true);
// `|| true` is to prevent the bar from jumping to mobile (top:30) causing animation jank
